module.exports = __webpack_public_path__ + "img/footer_bg.6a1d5ae0.png";